import en from './locales/en.json';

const locales: Record<string, Record<string, string>> = {
  en,
};

const DEFAULT_LANG = 'en';

export const t = (key: string) => {
  return locales[DEFAULT_LANG][key] ?? key;
};

export default t;
